import React, { useEffect, useState } from "react";
import {
  Button,
  Label,
  Dialog,
  DialogSurface,
  DialogBody,
  DialogActions,
  DialogContent,
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionPanel,
  DialogTitle,
  PresenceBadge,
  Badge,
  Spinner,
  Toast,
  ToastTitle,
  ToastTrigger,
  Link,
  Dropdown,
  useToastController,
  useId,
  ToastBody,
  Toaster,
  MenuItem,
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  Field,
  Divider,
  makeStyles,
} from "@fluentui/react-components";
import {
  Edit24Filled,
  AttachRegular,
  DismissRegular,
  ChevronDownRegular,
} from "@fluentui/react-icons";
import ClientSelection from "./ClientSelection";
import { useSelector, useDispatch } from "react-redux";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "../style.css";
import "../../client/style.css";
import Dropzone from "react-dropzone";
import apiServices from "../../../service";
import OverlayLoader from "../../../components/OverlayLoader";
import { generateUUID, getUserId } from "../../../utils";
import "./styles.css";
import MaterialReactTable, { MRT_ColumnDef } from "material-react-table";
import ASCButton from "../../../components/Button";
import DynamicDropzone from "../../../components/DynamicDropzone/Dropzone";

interface Template {
  code: string;
  title: string;
  Body: string;
  Description: string;
}

type selectedValue = {
  customer_id: string;
  first_names: string;
  last_name: string;
  email: string;
};
const modules = {
  toolbar: false,
};

const useStyles = makeStyles({
  listbox: {
    maxHeight: "40vh !important",
    overflowY: "auto",
  },
});

const TemplateDropdown: React.FC = () => {
  const styles = useStyles();
  const [selectedTemplate, setSelectedTemplate] = useState<string>("");
  const [selectedTemplateId, setSelectedTemplateId] = useState<string | null>(
    null
  );
  const [template, setTemplate] = useState<Template[]>([]);

  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [clients, setClients] = useState<selectedValue[]>([]);
  const [messageBody, setMessageBody] = useState<string>("");
  const [showClientSelection, setShowClientSelection] = useState(false);
  const [selectedClient, setSelectedClient] = useState<selectedValue[]>([]);
  const [previewList, setPreviewList] = useState<any>([]);
  const [mailCount, setMailCount] = useState(0);
  const [totalMails, setTotalMails] = useState(0);
  const [sendingMail, setSendingMail] = useState<boolean>(false);
  const [mailStatus, setMailStatus] = useState([]);
  const [enableEdit, setEnableEdit] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedItemId, setSelectedItemId] = useState("");
  const { userProfileInfo } = useSelector((state: any) => state.authUser);
  const [rawFiles, setRawFiles] = useState<{ [customerId: string]: File[] }>({});
  const [scannedFiles, setScannedFiles] = useState<{ [customerId: string]: any[] }>({});
  const userId = getUserId();
  const [messageContent, setMessageContent] = useState<any>("");
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const toasterId = useId("toaster");
  const { dispatchToast } = useToastController(toasterId);

  const notify = (title?: string, message?: string, type?: any) =>
    dispatchToast(
      <Toast>
        <ToastTitle
          action={
            <ToastTrigger>
              <Link>Dismiss</Link>
            </ToastTrigger>
          }
        >
          {title ?? title}
        </ToastTitle>
        <ToastBody>{message ?? message}</ToastBody>
      </Toast>,
      { intent: type ? type : "success" }
    );

  const NOTIFICATION_ID = generateUUID();
  const handleContinue = (): void => {
    setShowPopup(false);
    setShowConfirmation(true);
  };

  const handleConfirmation = (confirmed: boolean): void => {
    setShowConfirmation(false);
    if (confirmed) {
      resetPage();
    }
  };

  const generatePreviewList = (templateId: string, selClients: any) => {
    if (templateId !== undefined && selClients && selClients.length > 0) {
      selClients.map((client: any) => getMessageBody(templateId, client));
    }
  };

  const handleMenuItemClick = (text: string, code: string) => {
    setSelectedTemplate(text);
    setSelectedTemplateId(code);
  };

  const renderedMenuItems = template.map((item: Template) => (
    <MenuItem
      style={{ width: "400px" }}
      key={item.code}
      onClick={() => handleMenuItemClick(item.title, item.code)}
    >
      {item.title}
    </MenuItem>
  ));

  const getMessageBody = (templateId: string, customer: any) => {
    setLoading(true);
    apiServices.notification
      .createContent(templateId, customer.customer_id)
      .then((response: any) => {
        setLoading(false);
        if (response.data) {
          const { Body, Subject, Placeholders } = response.data;
          const messageBody = response.data.templateContent;
          setMessageContent(response.data.templateContent);
          const newPreviewItem = {
            body: messageBody,
            subject: Subject,
            placeholders: Placeholders,
            customer,
            edited: false,
          };
          setPreviewList((prevList: any) => [...prevList, newPreviewItem]);
        }
      })
      .catch((e: Error) => {
        setLoading(false);
        console.log(e);
      });
  };

  const handleCallPreview = () => {
    if (selectedTemplateId) {
      generatePreviewList(selectedTemplateId, selectedClient);
    }
  };
  const handleClientSelection = (selectedIds: any) => {
    if (selectedIds && selectedIds.length > 0) {
      setSelectedClient(selectedIds);
    }
  };

  const removeFile = (clientId: string) => {
    setRawFiles((prev) => { const n = { ...prev }; delete n[clientId]; return n; });
    setScannedFiles((prev) => { const n = { ...prev }; delete n[clientId]; return n; });
  };

  const isCustomerFileProcessing = (customerId: string) =>
    (scannedFiles[customerId] || []).some(
      (f: any) => f.status === "uploading" || f.status === "scanning"
    );

  const isAnyFileProcessing = Object.values(scannedFiles).some((files) =>
    files.some((f: any) => f.status === "uploading" || f.status === "scanning")
  );

  const handleSendMail = () => {
    if (previewList.length > 0) {
      setShowConfirmation(false);
      setSendingMail(true);

      const editedItems = previewList.filter(
        (item: any) => item.edited === true
      );
      const nonEditedItems = previewList.filter(
        (item: any) => item.edited === false
      );

      const initialStatus = previewList.map((item: any) => ({
        customer: item.customer,
        status: "pending",
        item,
      }));
      setMailStatus(initialStatus);

      const updateStatus = (index: number, status: string) => {
        setMailStatus((prevList) => {
          const newList: any = [...prevList];
          newList[index] = { ...newList[index], status };
          return newList;
        });
      };

      const sendIndividualEmail = (item: any, index: number) => {
        const formData = new FormData();
        formData.append("customerId", item.customer.customer_id);
        formData.append("subject", selectedTemplate);
        formData.append("cc", userProfileInfo.user_email);
        formData.append("from", userProfileInfo.user_email);
        formData.append("body", item.body);
        formData.append("notificationId", NOTIFICATION_ID);
        const objectIds = (scannedFiles[item.customer.customer_id] || [])
          .filter((f: any) => f.objectId)
          .map((f: any) => f.objectId)
          .join(",");
        if (objectIds) formData.append("objectIds", objectIds);
        return apiServices.notification
          .sendEmail(formData)
          .then((res) => {
            if (res.data.isError) {
              const errorMsg = Array.isArray(res.data.error?.message)
                ? res.data.error.message.join(", ")
                : res.data.error?.message || "Unknown error";
              notify("Error", errorMsg, "error");
              updateStatus(index, "failed");
            } else {
              notify(res.data.message, "", "success");
              updateStatus(index, "completed");
            }
            setMailCount((prevCount) => prevCount + 1);
          })
          .catch((err) => {
            notify("Error", err.message || "Failed to send email", "error");
            updateStatus(index, "failed");
            setMailCount((prevCount) => prevCount + 1);
          });
      };

      const sendBulkEmail = async (items: any[]) => {
        const customerIds = items.map((item) => item.customer.customer_id);
        const bulkEmailItems = previewList.filter((item: any) =>
          customerIds.includes(item.customer.customer_id)
        );

        let payload = {
          from: userProfileInfo.user_email,
          subject: selectedTemplate,
          body: selectedTemplateId,
          to: customerIds,
          cc: [userProfileInfo.user_email],
          notificationId: NOTIFICATION_ID,
        };

        const initialStatus = bulkEmailItems.map((item: any) => ({
          customer: item.customer,
          status: "pending",
          item,
        }));

        setMailStatus(initialStatus);
        setLoading(true);

        try {
          const res = await apiServices.notification.sendBulkEmail(payload);

          if (res.data.isError) {
            const errorMsg = Array.isArray(res.data.error?.message)
              ? res.data.error.message.join(", ")
              : res.data.error?.message || "Unknown error";
            notify("Error", errorMsg, "error");
            setMailStatus((prevStatus: any) =>
              prevStatus.map((status: any) =>
                customerIds.includes(status.customer.customer_id)
                  ? { ...status, status: "failed" }
                  : status
              )
            );
            setLoading(false);
            return;
          }

          notify(res.data.message, "", "success");
          setMailStatus((prevStatus: any) =>
            prevStatus.map((status: any) => {
              if (customerIds.includes(status.customer.customer_id)) {
                return { ...status, status: "completed" };
              }
              return status;
            })
          );
          setLoading(false);
        } catch (err) {
          console.log(err);
          setLoading(false);
          setMailStatus((prevStatus: any) =>
            prevStatus.map((status: any) =>
              customerIds.includes(status.customer.customer_id)
                ? { ...status, status: "failed" }
                : status
            )
          );
        }
      };

      if (editedItems.length > 0) {
        const individualPromises = editedItems.map((item: any, index: number) =>
          sendIndividualEmail(item, index)
        );
        Promise.all(individualPromises)
          .then(() => {
            if (nonEditedItems.length > 0) {
              return sendBulkEmail(nonEditedItems);
            }
          })
          .then(() => {
            if (nonEditedItems.length > 0) {
            }
          })
          .catch((error) => {
            console.error("Error sending emails:", error);
          });
        setTotalMails(previewList.length);
        setMailCount(0);
        setShowConfirmation(false);
        setSendingMail(true);
        setLoading(false);
      } else if (nonEditedItems.length > 0) {
        sendBulkEmail(nonEditedItems);
        setTotalMails(previewList.length);
        setMailCount(0);
        setShowConfirmation(false);
        setSendingMail(true);
        setLoading(false);
      } else {
        setShowConfirmation(false);
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (
      mailStatus.length > 0 &&
      mailStatus.every((item: any) => item.status === "completed")
    ) {
      const timer = setTimeout(() => {
        setSendingMail(false);
      }, 1000);
      resetPage();
      return () => clearTimeout(timer);
    } else if (
      mailStatus.length > 0 &&
      mailStatus.every((item: any) => item.status === "failed")
    ) {
      setSendingMail(false);
      resetPage();
    }
  }, [mailStatus]);

  const resetPage = () => {
    setSelectedTemplate("");
    setSelectedTemplateId("");
    setShowPopup(false);
    setShowConfirmation(false);
    setSelectedOptions([]);
    setSelectedClient([]);
    setMessageBody("");
    setPreviewList([]);
    setRawFiles({});
    setScannedFiles({});
  };
  const columnsData: MRT_ColumnDef<any>[] = [
    {
      accessorKey: "title", // Key to identify column data
      header: "Title",
    },
    {
      accessorKey: "description",
      header: "Description",
    },
    {
      accessorKey: "signedUrl",
      header: "Link",
      Cell: ({ row }: any) => (
        <>
          <a href={row.original.signedUrl} style={{ textDecoration: "none" }}>
            {row.original.title} - {row.original.templateFilePath}
          </a>{" "}
        </>
      ),
    },
  ];
  const handleRowSelection = (row: any) => {
    setSelectedRow(row.original);
  };

  ////////////////////
  const getClientPlaceholder = () => {
    if (selectedClient.length === 0) {
      return "Select a Client / Multiple Clients";
    } else if (selectedClient.length === 1) {
      return `${selectedClient[0].first_names} ${selectedClient[0].last_name}`;
    } else if (selectedClient.length === 2) {
      return `${selectedClient[0].first_names} ${selectedClient[0].last_name}, ${selectedClient[1].first_names} ${selectedClient[1].last_name}`;
    } else {
      return `${selectedClient[0].first_names}, ${selectedClient[1].first_names
        } + ${selectedClient.length - 2} others`;
    }
  };
  const getEmailList = () => {
    apiServices.TemplateEngine.getEmailTemplate().then((res) => {
      const filteredTemplates = res.data.filter(
        (item: { status: string }) => item.status === "Completed"
      );
      setTemplate(filteredTemplates);
    });
  };

  useEffect(() => {
    getEmailList();
  }, []);

  return (
    <>
      <div className="main-container">
        <div style={{ overflow: "auto", scrollbarWidth: "thin", scrollbarColor: "#20539380 #f1f1f1" }}>
          <Toaster toasterId={toasterId} position="top-end" timeout={5000} />
          <OverlayLoader isLoading={loading} />

          <div className="send_mail_section">
            <Field className="send_mail_client">
              <label style={{ minWidth: "150px" }}>Select Template :</label>
              <Menu>
                <MenuTrigger disableButtonEnhancement>
                  <Button
                    shape="rounded"
                    style={{
                      fontWeight: "normal",
                      width: "350px",
                      color: "#606060",
                      border: "1px solid grey",
                      justifyContent: "flex-start",
                      textAlign: "left",
                      paddingLeft: "10px",
                    }}
                  // disabled={selectedClient.length === 0} // Disable if no clients are selected
                  >
                    <span style={{ flexGrow: 1, textAlign: "left" }}>
                      {selectedTemplate || "Select Template"}
                    </span>
                    <ChevronDownRegular />
                  </Button>
                </MenuTrigger>
                <MenuPopover
                  style={{
                    minWidth: "350px",
                    minHeight: "fit-content",
                    maxHeight: "40vh",
                    overflowX: "hidden",
                    overflowY: "scroll",
                  }}
                >
                  <MenuList style={{ minWidth: "350px", maxHeight: "40vh" }}>
                    {renderedMenuItems}
                  </MenuList>
                </MenuPopover>
              </Menu>
            </Field>

            <Field className="send_mail_client">
              <label style={{ minWidth: "150px" }}>Select Client(s):</label>

              <Dropdown
                disabled={selectedTemplate.length === 0}
                style={{ width: "350px" }}
                placeholder={getClientPlaceholder()}
                onClick={() => {
                  setShowClientSelection(true);
                }}
              ></Dropdown>
            </Field>
          </div>

          {selectedTemplate.length > 0 && (
            <>
              <div className="send_mail_client">
                <Label className="label">From :</Label>
                <Label>{userProfileInfo.user_email || ""}</Label>
                <Label className="label">Cc : </Label>
                <Label>{userProfileInfo.user_email || ""}</Label>
                <Label className="label">Subject</Label>
                <Label>{selectedTemplate}</Label>
              </div>
            </>
          )}
          {selectedTemplate.length > 0 && <Divider style={{ marginTop: 6 }} />}

          <div style={{
            overflow: "auto",
            //  height: "calc(100vh - 260px)" 
          }}>
            {previewList.length > 0 && selectedTemplate.length > 0 ? (
              previewList.map((item: any, index: number) => (
                <Accordion
                  key={index}
                  collapsible
                  defaultOpenItems={index === 0 ? [index] : []}
                >
                  <AccordionItem value={index}>
                    <AccordionHeader>
                      {item.customer.first_names}
                    </AccordionHeader>
                    {item.body && (
                      <AccordionPanel className="custom_accordion">
                        {enableEdit &&
                          selectedItemId === item.customer.customer_id ? (
                          <>
                            <Dropzone
                              multiple={true}
                              onDrop={(acceptedFiles: File[]) => {
                                if (acceptedFiles.length > 0) {
                                  setRawFiles((prev) => ({
                                    ...prev,
                                    [item.customer.customer_id]: [
                                      ...(prev[item.customer.customer_id] || []),
                                      ...acceptedFiles,
                                    ],
                                  }));
                                }
                              }}
                            >
                              {({ getRootProps, getInputProps }) => (
                                <div {...getRootProps({ className: "flex-end" })}>
                                  <input {...getInputProps()} />
                                  <AttachRegular
                                    fontSize="20px"
                                    style={{ cursor: "pointer" }}
                                  />
                                </div>
                              )}
                            </Dropzone>
                            <ReactQuill
                              value={item.body}
                              onChange={(value) => {
                                const updatedList = [...previewList];
                                updatedList[index].body = value;
                                setPreviewList(updatedList);
                              }}
                              modules={modules}
                              style={{ border: "none", padding: 0 }}
                            />
                            <DynamicDropzone
                              style={{ marginTop: "8px" }}
                              multiple={true}
                              externalFiles={rawFiles[item.customer.customer_id] || []}
                              onFilesChange={(files: any) => {
                                setScannedFiles((prev) => ({
                                  ...prev,
                                  [item.customer.customer_id]: files,
                                }));
                                if (files.length === 0) {
                                  setRawFiles((prev) => {
                                    const n = { ...prev };
                                    delete n[item.customer.customer_id];
                                    return n;
                                  });
                                }
                              }}
                              userId={userId}
                            />
                            <div className="action_buttons">
                              <ASCButton
                                shape="rounded"
                                className="asc-button-primary"
                                appearance="primary"
                                onClick={() => {
                                  removeFile(item.customer.customer_id);
                                  setEnableEdit(false);
                                  setSelectedItemId("");
                                }}
                                size="medium"
                                label="Cancel"
                              />
                              <ASCButton
                                shape="rounded"
                                appearance="secondary"
                                disabled={isCustomerFileProcessing(item.customer.customer_id)}
                                onClick={() => {
                                  setEnableEdit(false);
                                  setSelectedItemId("");
                                  setPreviewList((prevList: any) =>
                                    prevList.map((item: any, i: number) =>
                                      i === index
                                        ? { ...item, edited: true }
                                        : item
                                    )
                                  );
                                }}
                                size="medium"
                                label={isCustomerFileProcessing(item.customer.customer_id) ? "Scanning..." : "Save"}
                              />
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="flex-end">
                              <ASCButton
                                shape="rounded"
                                icon={<Edit24Filled />}
                                size="medium"
                                style={{ border: "none" }}
                                onClick={() => {
                                  setEnableEdit(true);
                                  setSelectedItemId(item.customer.customer_id);
                                }}
                              />
                            </div>
                            <div
                              dangerouslySetInnerHTML={{ __html: item.body }}
                            ></div>
                            <div className="file_upload_list">
                              {(scannedFiles[item.customer.customer_id] || [])
                                .filter((f: any) => f.status === "success")
                                .map((f: any, i: number) => (
                                  <div
                                    className="file_upload_detail"
                                    key={`${item.customer.customer_id}-${i}`}
                                  >
                                    <div>
                                      <p>{f.file?.name}</p>
                                      <span style={{ fontSize: 12 }}>
                                        {((f.file?.size || 0) / 1024).toFixed(2)} KB
                                      </span>
                                    </div>
                                    <DismissRegular onClick={() => removeFile(item.customer.customer_id)} />
                                  </div>
                                ))}
                            </div>
                          </>
                        )}
                      </AccordionPanel>
                    )}
                  </AccordionItem>
                </Accordion>
              ))
            ) : (
              <div
                style={{
                  textAlign: "center",
                  padding: "20px",
                  color: "#f00",
                  height: "calc(100vh - 460px)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                No template to preview
              </div>
            )}
          </div>

          {selectedTemplate.length > 0 &&
            selectedClient.length > 0 &&
            previewList.length > 0 && (
              <div className="message_buttons">
                <ASCButton
                  shape="rounded"
                  appearance="secondary"
                  onClick={resetPage}
                  label="Cancel"
                />
                <ASCButton
                  shape="rounded"
                  className="asc-button-primary"
                  appearance="primary"
                  disabled={isAnyFileProcessing}
                  onClick={() => {
                    handleContinue();
                  }}
                  label={isAnyFileProcessing ? "Scanning..." : selectedClient.length === 1 ? "Send" : "Send All"}
                />
              </div>
            )}
          <Dialog
            open={showClientSelection}
            onOpenChange={(event, data) => setShowClientSelection(data.open)}
          >
            <DialogSurface style={{ maxWidth: "55vw" }}>
              <DialogBody>
                <span className="mui-table">Client Selection</span>
                <DialogContent>
                  <ClientSelection
                    handleClientSelection={handleClientSelection}
                    setClientList={setClients}
                  />
                </DialogContent>
                <DialogActions>
                  <ASCButton
                    shape="rounded"
                    appearance="secondary"
                    onClick={() => setShowClientSelection(false)}
                    size="medium"
                    label="Close"
                  />
                  <ASCButton
                    shape="rounded"
                    className="asc-button-primary"
                    appearance="primary"
                    onClick={() => {
                      setShowClientSelection(false);
                      handleCallPreview();
                    }}
                    size="medium"
                    label="Select"
                  />
                </DialogActions>
              </DialogBody>
            </DialogSurface>
          </Dialog>
          {showConfirmation && (
            <Dialog
              open={showConfirmation}
              onOpenChange={(event, data) => setShowConfirmation(data.open)}
            >
              <DialogSurface>
                <DialogBody>
                  <DialogTitle>Confirmation for sending mail</DialogTitle>
                  <DialogActions>
                    <ASCButton
                      shape="rounded"
                      appearance="secondary"
                      onClick={() => handleConfirmation(false)}
                      size="medium"
                      label="Cancel"
                    />
                    <ASCButton
                      shape="rounded"
                      className="asc-button-primary"
                      appearance="primary"
                      onClick={() => handleSendMail()}
                      size="medium"
                      label="Send Email"
                    />
                  </DialogActions>
                </DialogBody>
              </DialogSurface>
            </Dialog>
          )}
          {sendingMail && (
            <Dialog
              open={sendingMail}
              onOpenChange={(event, data) => setSendingMail(data.open)}
            >
              <DialogSurface>
                <DialogBody>
                  <DialogTitle>Sending Mail</DialogTitle>
                  <DialogContent>
                    {mailStatus.map((item: any, index) => (
                      <div key={index} className="mail_status">
                        {item.status === "completed" ? (
                          <PresenceBadge status="available" />
                        ) : item.status === "failed" ? (
                          <PresenceBadge status="do-not-disturb" />
                        ) : (
                          <Spinner size="tiny" />
                        )}
                        <span>
                          {item.customer.last_name}, {item.customer.first_names}
                        </span>
                      </div>
                    ))}
                  </DialogContent>

                  <DialogActions>
                    <ASCButton
                      shape="rounded"
                      appearance="secondary"
                      disabled={mailCount == totalMails ? false : true}
                      onClick={() => {
                        setSendingMail(false);
                        resetPage();
                      }}
                      size="medium"
                      label="Close"
                    />
                  </DialogActions>
                </DialogBody>
              </DialogSurface>
            </Dialog>
          )}
        </div>
      </div>
    </>
  );
};

export default TemplateDropdown;
